import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Top from "../Top";
import QuickActionsSidebar from "./QuickActionsSidebar";
// import PurchaseModule from "./PurchaseModule";
import { getActionsByUserType, getDistributorActions } from "../../../config/actions";
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
import { API_URL } from "../../../config";
import "../../css/QuickActions.css";
import "./DistributorDashboard.css";
import SystemRow from "./SystemRow";
import ModuleRow from "./ModuleRow";
import { getCurrencySymbol } from "../../../utils/currency";
import ResendConfirmationModal from "./ResendConfirmationModal";
import CancelOrderModal from "./CancelOrderModal";
import CreateOrderModal from "./CreateOrderModal";
import generateOrderPdf, { generateRefundReceiptPdf } from "./generateOrderPdf";
import Pagination from "../../common/Pagination";

const DistributorDashboard = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("user_name");
  const userType = localStorage.getItem("user_type");

  // if (userType !== "6") {
  //   navigate("/");
  //   return null;
  // }

  const isAdmin = userType === "7" || userType === 7;
 
  const [distributorFilter, setDistributorFilter] = useState("");
  const [distributorsList, setDistributorsList] = useState([]);
  const effectiveDistributorMd5 = isAdmin ? distributorFilter : userId;

  const [stats, setStats] = useState({
    capnoGo: {
      purchased: 0,
      inventory: 0,
    },
    modules: {
      purchased: 0,
      type: {},
      inventory: 0,
    },
    system: {
      purchased: 0,
      type: {},
      inventory: 0,
    },
    loading: true,
  });

  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const ORDERS_PAGE_SIZE = 10;
  const [ordersCurrentPage, setOrdersCurrentPage] = useState(1);
  const ordersTotalPages = Math.max(
    1,
    Math.ceil(filteredOrders.length / ORDERS_PAGE_SIZE)
  );
  const paginatedOrders = filteredOrders.slice(
    (ordersCurrentPage - 1) * ORDERS_PAGE_SIZE,
    ordersCurrentPage * ORDERS_PAGE_SIZE
  );
  const [txnStats, setTxnStats] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  const [sortField, setSortField] = useState("date");
  const [sortOrder, setSortOrder] = useState("desc");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

const [filters, setFilters] = useState({
  orderId: "",
  customerName: "",
  system: "all",
  module: "all",
  site: "all",
});
const [orderStatusTab, setOrderStatusTab] = useState("confirmed");


  const [orderDetailsModal, setOrderDetailsModal] = useState(false);
  const [selectedOrderDetail, setSelectedOrderDetail] = useState(null);
  const [resendModalOpen, setResendModalOpen] = useState(false);
  const [selectedOrderIdForResend, setSelectedOrderIdForResend] = useState(null);
  const [cancelOrderModalOpen, setCancelOrderModalOpen] = useState(false);
  const [createOrderOpen, setCreateOrderOpen] = useState(false);
  const [selectedOrderForCancel, setSelectedOrderForCancel] = useState(null);
  const [orderDetailLoading, setOrderDetailLoading] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [allSystem, setAllSystem] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
   const [allModules, setAllModules] = useState([]);
  const [sites, setSites] = useState([]);

  const [breakdownModal, setBreakdownModal] = useState(false);
  const [breakdownType, setBreakdownType] = useState(null); // 'modules' or 'system'
  const [moduleBreakdown, setModuleBreakdown] = useState({
    advancedFeatures: 0,
    cellphone: 0,
    clients: 0,
    esports: 0,
    groupwork: 0,
    hrv: 0,
    management: 0,
    muscles: 0,
    practicums: 0,
    trainers: 0,
  });
  const [systemBreakdown, setSystemBreakdown] = useState({
    basic: 0,
    esports: 0,
    advanced: 0,
    professional: 0,
    group: 0,
    upgrades: 0,
  });

  useEffect(() => {
    fetchAllSystem()
    fetchModules()
    fetchSites()
    if (isAdmin) fetchDistributorsList();
    
  }, []);

  // Re-runs on mount (distributorFilter starts at "") and again whenever
  // an admin picks a different distributor from the filter — a real
  // distributor never changes this, so it only ever fires once for them.
  useEffect(() => {
    fetchStats();
    fetchOrders();
    fetchTxnStats();
    if (effectiveDistributorMd5) {
      getDistributorOrderHistory(effectiveDistributorMd5);
    } else {
      setOrderHistory({});
    }
  }, [distributorFilter]);

useEffect(() => {
  applyFiltersAndSort();
}, [
  orders,
  filters,
  sortField,
  sortOrder,
  startDate,
  endDate,
  orderStatusTab,
]);

  useEffect(() => {
    updateStatsForSystemFilter();
  }, [filters.system, orders]);
const getDistributorOrderHistory = async (distributorId) => {
  try {
    const response = await fetch(
      `${API_URL}/order-history/${distributorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();

    // =========================
    // ✅ SYSTEM COUNT MAP
    // =========================
    const systemCountMap = {};

    data?.deviceHistory?.forEach((item) => {
      const productId = item.product_id;

      if (!systemCountMap[productId]) {
        systemCountMap[productId] = 0;
      }

      systemCountMap[productId] += Number(item.quantity || 0);
    });

    // =========================
    // ✅ MODULE COUNT MAP
    // =========================
    const moduleCountMap = {};

    data?.moduleHistory?.forEach((item) => {
      const moduleId = item.module_id;

      if (!moduleCountMap[moduleId]) {
        moduleCountMap[moduleId] = 0;
      }

      moduleCountMap[moduleId] += Number(item.quantity || 0);
    });

    setOrderHistory({
      ...data,
      systemCountMap,
      moduleCountMap,
    });

    return {
      ...data,
      systemCountMap,
      moduleCountMap,
    };

  } catch (error) {
    console.error("Order History Error:", error);

    return null;
  }
};
const fetchAllSystem = async () => {
  try {
    const response = await fetch(
      `${API_URL}/get/specified/product/by/22`
    );

    const res = await response.json();

    const defaultSystems = (res.data || []).filter(
      (item) => item.id >= 130 && item.id <= 134
    );

    setAllSystem(defaultSystems);
  } catch (error) {
    console.log(error);
  }
};
const fetchModules = async () => {
  try {
    const response = await fetch(`${API_URL}/get/all/modules`);

    const res = await response.json();

    if (response.status === 200) {
      setAllModules(res?.modules || []);
    }
  } catch (err) {
    console.log(err);
  }
};
const fetchSites = async () => {
  try {
    const response = await fetch(`${API_URL}/distributor/site/${userId}`, {
      headers: { "x-access-token": localStorage.getItem("accessToken") },
    });

    const res = await response.json();

    if (res.status && Array.isArray(res.data)) {
      setSites(res.data);
    }
  } catch (err) {
    console.log(err);
  }
};

const fetchDistributorsList = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    const res = await fetch(`${API_URL}/admin/distributors`, {
      headers: { "x-access-token": token },
    });
    const data = await res.json();
    setDistributorsList(data.distributors || []);
  } catch (err) {
    console.error("Error fetching distributors:", err);
  }
};

  const fetchStats = async () => {
    // Admin viewing "all distributors" has no single distributor to scope
    // these per-distributor stats to — leave the cards hidden instead.
    if (isAdmin && !distributorFilter) {
      setStats((prev) => ({ ...prev, loading: false }));
      return;
    }
    try {
      setStats((prev) => ({ ...prev, loading: true }));
      const token = localStorage.getItem("accessToken");
      const scopeId = effectiveDistributorMd5;

      const [six, seven, five, modules] = await Promise.all([
        fetch(`${API_URL}/get/six/customer/details?distributer=${scopeId}`, {
          headers: { "x-access-token": token },
        }).then((r) => r.json()),
        fetch(`${API_URL}/get/seven/customer/details?distributer=${scopeId}`, {
          headers: { "x-access-token": token },
        }).then((r) => r.json()),
        fetch(`${API_URL}/get/five/customer/details?distributer=${scopeId}`, {
          headers: { "x-access-token": token },
        }).then((r) => r.json()),
        fetch(`${API_URL}/get/all/modules`, {
          headers: { "x-access-token": token },
        }).then((r) => r.json()),
      ]);

      const capnoGoCustomers = seven.data || [];
      const sixCustomers = six.data || [];
      const fiveCustomers = five.data || [];

      // Capno Go Stats
      const capnoGoPurchased = capnoGoCustomers.filter(
        (c) => c.eid || c.owner_id
      ).length;
      const capnoGoInventory = capnoGoCustomers.length;

      // System Stats (Device 6.0 and Device 5.0)
      const systemCustomers = [...sixCustomers, ...fiveCustomers];
      const systemPurchased = systemCustomers.filter(
        (c) => c.eid || c.owner_id
      ).length;
      const systemInventory = systemCustomers.length;

      // Modules Stats
      const modulesAvailable = (modules.modules || []).length;
      const modulesPurchased = Math.floor(
        (capnoGoPurchased + systemPurchased) * 0.6
      );

      setStats({
        capnoGo: {
          purchased: capnoGoPurchased,
          inventory: capnoGoInventory,
        },
        modules: {
          purchased: modulesPurchased,
          type: {},
          inventory: modulesAvailable,
        },
        system: {
          purchased: systemPurchased,
          type: {},
          inventory: systemInventory,
        },
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching stats:", error);
      setStats((prev) => ({ ...prev, loading: false }));
    }
  };

  const updateStatsForSystemFilter = () => {
    if (filters.system === "all" || !orders.length) {
      return;
    }

    const systemOrders = orders.filter((order) => order.system === filters.system);
    const systemPurchased = systemOrders.filter((order) => order.status === "Active").length;
    const systemInventory = systemOrders.length;

    setStats((prev) => ({
      ...prev,
      system: {
        ...prev.system,
        purchased: systemPurchased,
        inventory: systemInventory,
      },
    }));
  };

  const fetchOrders = async () => {
  setOrdersLoading(true);

  try {
    const token = localStorage.getItem("accessToken");

    // Admin with no distributor picked sees every distributor's orders;
    // otherwise (a real distributor, or an admin who picked one) it's
    // scoped to that single distributor as before.
    const url =
      isAdmin && !distributorFilter
        ? `${API_URL}/admin/orders`
        : `${API_URL}/get/distributor/all-order?distributor_id=${effectiveDistributorMd5}`;

    const res = await fetch(url, {
      headers: { "x-access-token": token },
    });

    const response = await res.json();
   

 const customerOrders = (response.items || []).map((customer) => {
  let address = {};
  let billingAddress = {};
  let transaction_body = {};

  try {
    address = JSON.parse(customer.shipping_address_info || "{}");
  } catch (e) {
    console.warn("Invalid JSON in shipping_address_info:", customer);
  }

  try {
    billingAddress = JSON.parse(customer.billing_address_info || "{}");
  } catch (e) {
    console.warn("Invalid JSON in billing_address_info:", customer);
  }
  try {
    transaction_body = JSON.parse(customer.transaction_body || "{}");
  } catch (e) {
    console.warn("Invalid JSON in transaction_body:", customer);
  }

  // ✅ SYSTEM NAMES
  const systemNames =
    customer.items?.map((item) => item.product_name).join(", ") || "—";

  // ✅ MODULE IDS (primary + additional modules merged for filter)
  const moduleIds =
    customer.module_ids?.map((id) => Number(id)) || [];

  const additionalModuleIds = (customer.additional_modules || [])
    .flatMap((am) => am.modules?.map((m) => Number(m.id)) || []);

  const allModuleIds = [...new Set([...moduleIds, ...additionalModuleIds])];

  // ✅ PRODUCT IDS
  const productIds =
    customer.product_ids?.map((id) => Number(id)) || [];

  // ✅ MODULE NAMES
  const moduleNames =
    customer.items
      ?.flatMap((item) => item.modules || [])
      ?.map((m) => m.name)
      ?.join(", ") || "—";

  const serialNumbers = customer.serial_numbers
    ? Array.isArray(customer.serial_numbers)
      ? customer.serial_numbers
      : [customer.serial_numbers]
    : customer.serial_number
    ? [customer.serial_number]
    : [];

  return {
    id: customer?.order_id,
    customerId: customer.customer_id || customer.uid,
    customerName: `${address?.fname || ""} ${address?.lname || ""}`.trim(),
    distributorId: customer.distributorId,
  
    date: customer.created,
    status:
      customer.order_status === "CANCELLED"
        ? "Cancelled"
        : customer.order_status == "CONFIRM"
        ? "Active"
        : "Pending",
    order_status: customer.order_status,
    cancellation_reason: customer.cancellation_reason || "",
    refund_id: customer.refund_id || "",
    refund_status: customer.refund_status || "",
    refund_amount: customer.refund_amount,
    quantity: customer.quantity || 1,
    amount: customer?.total_amount || 0,

    // ✅ corrected
    system: systemNames,
    moduleNames,
    siteName: customer.site_name || "—",

    // ✅ ids
    product_ids: productIds,
    module_ids: allModuleIds,

    additional_modules: customer.additional_modules || [],

    serialNumbers,

    // ✅ price breakup fields
    items: customer.items || [],
    product_total_price: customer?.product_total_price || 0,
    tax_amount: customer?.tax_amount || 0,
    Shipping_fee: customer?.Shipping_fee || 0,
    Insurance_fee: customer?.Insurance_fee || 0,
    discounted_amount: customer?.discounted_amount || 0,
    coupon_code: customer?.coupon_code || "",
    shippingMethod: customer?.shipping_method || "",
    deliveryDate: customer?.delivery_date || null,
    shipping_address: address,
    billing_address: billingAddress,
    transaction_body: transaction_body,
    currency_code: customer.currency || transaction_body?.purchase_units?.[0]?.amount?.currency_code || transaction_body?.currency|| "USD",
  };
});



    setOrders(customerOrders);
  } catch (error) {
    console.error("Error fetching orders:", error);
  } finally {
    setOrdersLoading(false);
  }
};
  const fetchTxnStats = async () => {
  if (isAdmin && !distributorFilter) {
    setTxnStats({});
    return;
  }

  try {
    const distributor_id = effectiveDistributorMd5;

    const res = await fetch(`${API_URL}/txn/${distributor_id}`);

    const response = await res.json();
    // console.log("txn response",response);
    setTxnStats(response)
  } catch (error) {
    console.error("Error fetching txn:", error);
  } 
};
const deviceAvailable = txnStats?.device?.[0]?.available || 0;
const devicePurchased = txnStats?.device?.[0]?.purchased || 0;
const moduleAvailable = txnStats?.module?.[0]?.available || 0;
const modulePurchased = txnStats?.module?.[0]?.purchased || 0;
// console.log(txnStats);

  // Every filter except the status tab itself — shared by the table
  // (applyFiltersAndSort adds the status filter on top of this) and by
  // the Active/Cancelled tab counts, so a filter narrows both together
  // instead of the counts staying stuck at the full unfiltered totals.
  const applyNonStatusFilters = (list) => {
    let filtered = [...list];

  if (filters.system !== "all") {
  filtered = filtered.filter((order) =>
    order.product_ids?.includes(Number(filters.system))
  );
}
if (filters.module !== "all") {
  filtered = filtered.filter((order) =>
    order.module_ids?.includes(Number(filters.module))
  );
}
if (filters.site !== "all") {
  filtered = filtered.filter((order) => order.siteName === filters.site);
}
    // Apply customer name filter
    if (filters.customerName) {
      filtered = filtered.filter((order) =>
        order.customerName.toLowerCase().includes(filters.customerName.toLowerCase())
      );
    }

    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter((order) => {
        const orderDate = new Date(order.date);
        if (startDate) {
          const start = new Date(startDate);
          start.setHours(0, 0, 0, 0);
          if (orderDate < start) return false;
        }
        if (endDate) {
          const end = new Date(endDate);
          end.setHours(23, 59, 59, 999);
          if (orderDate > end) return false;
        }
        return true;
      });
    }

    // Apply order ID filter (supports both single ID and range with dash)
    if (filters.orderId) {
      const idInput = filters.orderId.trim();

      // Check if it's a range (contains dash)
      if (idInput.includes("-")) {
        const [minStr, maxStr] = idInput.split("-").map(s => s.trim());
        const min = minStr ? parseInt(minStr) : -Infinity;
        const max = maxStr ? parseInt(maxStr) : Infinity;

        filtered = filtered.filter((order) => {
          const idNum = parseInt(String(order.id).match(/\d+/)?.[0] || "0");
          return idNum >= min && idNum <= max;
        });
      } else {
        // Single ID search
        filtered = filtered.filter((order) =>
          String(order.id).toLowerCase().includes(idInput.toLowerCase())
        );
      }
    }

    return filtered;
  };

  const applyFiltersAndSort = () => {
    let filtered = applyNonStatusFilters(orders);

    // Apply status tab filter
    filtered = filtered.filter((order) =>
      orderStatusTab === "cancelled"
        ? order.status === "Cancelled"
        : order.status !== "Cancelled"
    );

    // Apply sorting
    filtered.sort((a, b) => {
      let aVal, bVal;

      if (sortField === "date") {
        aVal = new Date(a.date).getTime();
        bVal = new Date(b.date).getTime();
      } else if (sortField === "id") {
        aVal = parseInt(String(a.id).match(/\d+/)?.[0] || "0");
        bVal = parseInt(String(b.id).match(/\d+/)?.[0] || "0");
      } else if (sortField === "name") {
        aVal = a.customerName.toLowerCase();
        bVal = b.customerName.toLowerCase();
      }

      if (sortOrder === "asc") {
        return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
      } else {
        return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
      }
    });

    setFilteredOrders(filtered);
    setOrdersCurrentPage(1);
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

const handleClearFilters = () => {
  setFilters({
    orderId: "",
    customerName: "",
    system: "all",
    module: "all",
    site: "all",
  });

  setStartDate(null);
  setEndDate(null);
};

  const togglePurchaseModal = () => {
    setPurchaseModal(!purchaseModal);
    if (!purchaseModal) {
      setPurchaseSuccess(false);
      setPurchaseForm({ quantity: "" });
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const handleViewOrderDetails = (order) => {
    setSelectedOrderDetail(order);
    setOrderDetailsModal(true);
  };

  const handleResendConfirmation = (order_id) => {
    setSelectedOrderIdForResend(order_id);
    setResendModalOpen(true);
  };

  const handleDownloadOrder = (order) => {
    if (order.status === "Cancelled") {
      generateRefundReceiptPdf(order);
    } else {
      generateOrderPdf(order);
    }
  };

  const handleCancelOrder = (order) => {
    setSelectedOrderForCancel(order);
    setCancelOrderModalOpen(true);
  };

  const toggleCancelOrderModal = () => {
    setCancelOrderModalOpen(!cancelOrderModalOpen);
    if (cancelOrderModalOpen) {
      setSelectedOrderForCancel(null);
    }
  };

  const handleCancelOrderSuccess = () => {
    fetchOrders();
  };

  const toggleOrderDetailsModal = () => {
    setOrderDetailsModal(!orderDetailsModal);
    if (orderDetailsModal) {
      setSelectedOrderDetail(null);
    }
  };


  const handleEyeClick = (type) => {
    setBreakdownType(type);
    setBreakdownModal(true);

    // Distribute sold counts across types
    if (type === 'modules') {
      const totalModulesSold = stats.modules.purchased;
      const distribution = {
        advancedFeatures: Math.floor(totalModulesSold * 0.12),
        cellphone: Math.floor(totalModulesSold * 0.1),
        clients: Math.floor(totalModulesSold * 0.1),
        esports: Math.floor(totalModulesSold * 0.12),
        groupwork: Math.floor(totalModulesSold * 0.1),
        hrv: Math.floor(totalModulesSold * 0.1),
        management: Math.floor(totalModulesSold * 0.1),
        muscles: Math.floor(totalModulesSold * 0.1),
        practicums: Math.floor(totalModulesSold * 0.1),
        trainers: Math.floor(totalModulesSold * 0.05),
      };
      const sum = Object.values(distribution).reduce((a, b) => a + b, 0);
      distribution.trainers += totalModulesSold - sum;
      setModuleBreakdown(distribution);
    } else if (type === 'system') {
      const totalSystemSold = stats.system.purchased;
      const distribution = {
        basic: Math.floor(totalSystemSold * 0.25),
        esports: Math.floor(totalSystemSold * 0.2),
        advanced: Math.floor(totalSystemSold * 0.2),
        professional: Math.floor(totalSystemSold * 0.2),
        group: Math.floor(totalSystemSold * 0.1),
        upgrades: totalSystemSold - (Math.floor(totalSystemSold * 0.25) + Math.floor(totalSystemSold * 0.2) + Math.floor(totalSystemSold * 0.2) + Math.floor(totalSystemSold * 0.2) + Math.floor(totalSystemSold * 0.1)),
      };
      setSystemBreakdown(distribution);
    }
  };

  const [expandedSerialRow, setExpandedSerialRow] = useState(null);

  // Mirrors formatAddressLabeled() from generateOrderConfirmationHTMLUpdated
  // (capnolearner-api/controllers/productController.js) so the in-app
  // Order Details modal matches the order confirmation email: one labelled
  // line per field, empty fields skipped.
  const formatAddressLabeled = (a) => {
    if (!a) return null;
    const f = (v) =>
      v && String(v).trim() !== "" && String(v).toLowerCase() !== "undefined"
        ? String(v).trim()
        : "";
    const rows = [
      ["Name", [f(a.fname), f(a.lname)].filter(Boolean).join(" ")],
      ["Company", f(a.company)],
      ["Address", [f(a.address_1), f(a.address_2), f(a.address_3), f(a.address_4)].filter(Boolean).join(", ")],
      ["City", f(a.city)],
      ["State", f(a.state)],
      ["Country", f(a.country)],
      ["Postal Code", f(a.postal)],
    ];
    return rows
      .filter(([, value]) => value)
      .map(([label, value]) => (
        <React.Fragment key={label}>
          <strong>{label}:</strong> {value}
          <br />
        </React.Fragment>
      ));
  };

  const SerialNumberCell = ({ serialNumbers, orderId }) => {
    const isExpanded = expandedSerialRow === orderId;

    if (!serialNumbers || serialNumbers.length === 0) {
      return <span className="serial-number">—</span>;
    }

    if (serialNumbers.length === 1) {
      return <span className="serial-number">{serialNumbers[0]}</span>;
    }

    return (
      <div className="serial-number-dropdown">
        <div
          className="serial-number-main"
          onClick={() => setExpandedSerialRow(isExpanded ? null : orderId)}
          role="button"
          tabIndex="0"
          title={isExpanded ? "Collapse" : "Expand"}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setExpandedSerialRow(isExpanded ? null : orderId);
            }
          }}
        >
          <span>{serialNumbers[0]}</span>
          <i className={`fas fa-chevron-${isExpanded ? "up" : "down"}`}></i>
        </div>
        {isExpanded && (
          <div className="serial-number-dropdown-list">
            {serialNumbers.slice(1).map((serial, idx) => (
              <div key={idx} className="serial-number-item">
                {serial}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const StatMetric = ({ label, value, loading, icon, onEyeClick, showEyeIcon }) => (
    <div className="stat-metric">
      <div className="metric-icon">{icon}</div>
      <div className="metric-content">
        <p className="metric-label">{label}</p>
        <div className="metric-value-wrapper">
          {
            value &&
          <p className="metric-value">
            {loading ? <span className="loader-dot"></span> : value}
          </p>
          }
          
          {showEyeIcon && !loading && (
            <button
              className="eye-icon-btn"
              onClick={onEyeClick}
              title="View breakdown"
            >
              <i className="fas fa-arrow-down"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );

  const StatGroup = ({ title, icon, color, stats, loading, type, showTypeBreakdown,inventory,purchased,showInventory = true }) => (
    <div className={`stat-group stat-group-${color}`}>
      <div className="group-header">
        {/* <div className={`group-icon icon-${color}`}>{icon}</div> */}
        <h3>{title}</h3>
      </div>
      <div className="group-metrics">
        <StatMetric
          label="Purchased"
          value={`${purchased}`}
          loading={loading}
          // icon={<i className="fas fa-check-circle"></i>}
        />
       
        {showInventory && (
          <StatMetric
            label="Inventory"
            value={`${inventory}`}
            loading={loading}
            // icon={<i className="fas fa-boxes"></i>}
          />
        )}
         {showTypeBreakdown && (
          <StatMetric
            label="Types"
            // value={stats.purchased}
            loading={loading}
            // icon={<i className="fas fa-list"></i>}
            onEyeClick={() => handleEyeClick(type)}
            showEyeIcon={true}
          />
        )}
      </div>
    </div>
  );

  const actions = isAdmin
    ? getActionsByUserType("7",userId)
    : getDistributorActions(userId);

  return (
    <div>
      {/* <div className="cmail">
        <Top />
      </div> */}
      <div className="distributor-dashboard">
        <div className="dashboard-container">
          {/* Left Sidebar */}
          <QuickActionsSidebar actions={actions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu}  />

        {/* Main Content */}
        <div className="dashboard-content">
          {/* Welcome Header */}
          <div className="dashboard-header">
            <div className="header-content">
              <h1>Welcome back, {userName}! 👋</h1>
              <p>Here's your business overview.</p>
            </div>
          </div>

          {isAdmin && (
            <div className="filters-header" style={{ margin: 0 }}>
              <div className="filter-group">
                <label style={{margin:0}}>Filter Distributor:</label>
                <select
                  value={distributorFilter}
                  onChange={(e) => setDistributorFilter(e.target.value)}
                >
                  <option value="">All Distributors</option>
                  {distributorsList.map((dist) => (
                    <option key={dist.id} value={dist.distributor_id}>
                      {`${dist.firstname || ""} ${dist.lastname || ""}`.trim() ||
                        dist.business ||
                        `Distributor #${dist.id}`}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* Stats Groups — an admin viewing "all distributors" has no
              single distributor to scope these to, so they're hidden
              until one is picked from the filter above. */}
          {(!isAdmin || distributorFilter) && (
            <div className="stats-groups-container">
              <StatGroup
                title="CapnoGO"
                icon={<i className="fas fa-box"></i>}
                color="rgb(77, 0, 77)"
                stats={stats.capnoGo}
                purchased={devicePurchased}
                inventory={deviceAvailable}
                loading={stats.loading}
                showTypeBreakdown={false}
              />
              <StatGroup
                title="Modules"
                icon={<i className="fas fa-puzzle-piece"></i>}
                color="rgb(77, 0, 77)"
                stats={stats.modules}
                loading={stats.loading}
                inventory={moduleAvailable}
                purchased={modulePurchased}
                type="modules"
                showTypeBreakdown={true}
              />
              <StatGroup
                title="Systems"
                icon={<i className="fas fa-server"></i>}
                color="rgb(77, 0, 77)"
                stats={stats.system}
                purchased={devicePurchased}
                loading={stats.loading}
                type="system"
                showTypeBreakdown={true}
                showInventory={false}
              />
            </div>
          )}

          {/* Orders Section */}
          <div className="orders-section">
            <div className="orders-header">
              <div className="flex space-between">
                <h2>Orders</h2>
                <span className="order-count">({filteredOrders.length})</span>
              </div>
              <div className="orders-total">
                <span className="total-label">Sales:</span>
                <span className="total-amount">${parseFloat(filteredOrders.reduce((sum, order) => sum + (Number(order.amount) || 0), 0)).toLocaleString('en-US')}</span>
              </div>
            </div>

            {/* Status Tabs */}
            <div className="order-status-bar">
            <div className="order-status-tabs">
              <button
                type="button"
                className={`order-status-tab ${orderStatusTab === "confirmed" ? "active" : ""}`}
                onClick={() => setOrderStatusTab("confirmed")}
              >
                Active
                <span className="order-status-tab-count">
                  ({applyNonStatusFilters(orders).filter((order) => order.status !== "Cancelled").length})
                </span>
              </button>
              <button
                type="button"
                className={`order-status-tab ${orderStatusTab === "cancelled" ? "active" : ""}`}
                onClick={() => setOrderStatusTab("cancelled")}
              >
                Cancelled
                <span className="order-status-tab-count">
                  ({applyNonStatusFilters(orders).filter((order) => order.status === "Cancelled").length})
                </span>
              </button>
            </div>

              <button
                type="button"
                className="create-order-btn"
                onClick={() => setCreateOrderOpen(true)}
              >
                <i className="fas fa-plus"></i> Create Order
              </button>
            </div>

            {/* Filters */}
              <div className="filters-header">
              <span className="filters-label mr-1">Filters</span>
              <button
                className="clear-filters-btn"
              onClick={handleClearFilters}
              >
                Clear
              </button>
            </div>
            <div className="orders-filters">
              <div className="filter-group date-range-filter">
                <label>Date Range</label>
                <div className="range-inputs">
                  <input
                    type="date"
                    value={startDate ? startDate.toISOString().split('T')[0] : ""}
                    onChange={(e) => setStartDate(e.target.value ? new Date(e.target.value) : null)}
                    max={new Date().toISOString().split('T')[0]}
                  />
                  <span className="range-separator">to</span>
                  <input
                    type="date"
                    value={endDate ? endDate.toISOString().split('T')[0] : ""}
                    onChange={(e) => setEndDate(e.target.value ? new Date(e.target.value) : null)}
                    max={new Date().toISOString().split('T')[0]}
                    min={startDate ? startDate.toISOString().split('T')[0] : ""}
                  />
                </div>
              </div>

              <div className="filter-group">
                <label>Order #</label>
                <input
                  type="text"
                  placeholder="e.g., 123 or 100-200"
                  value={filters.orderId}
                  onChange={(e) => handleFilterChange("orderId", e.target.value)}
                  title="Enter a single ID (e.g., 123) or a range (e.g., 100-200)"
                />
              </div>

              <div className="filter-group">
                <label>Customers</label>
                <input
                  type="text"
                  className="font-medium text-black"
                  placeholder="Search by customer name..."
                  value={filters.customerName}
                  onChange={(e) => handleFilterChange("customerName", e.target.value)}
                  title="Enter customer name to search"
                />
              </div>

              <div className="filter-group ">
                <label>Systems</label>
         <select
  value={filters.system}
  onChange={(e) => handleFilterChange("system", e.target.value)}
>
  <option value="all">All Systems</option>

  {allSystem?.map((item) => (
    <option key={item.id} value={item.id}>
      {item.name}
    </option>
  ))}
</select>
              </div>

                <div className="filter-group">
                <label>Modules</label>
              <select
  className="font-normal"
  value={filters.module}
  onChange={(e) => handleFilterChange("module", e.target.value)}
>
  <option value="all">All Modules</option>

  {allModules?.map((module) => (
    <option key={module.id} value={module.id}>
      {module.name}
    </option>
  ))}
</select>
              </div>

              <div className="filter-group">
                <label>Site</label>
              <select
  className="font-normal"
  value={filters.site}
  onChange={(e) => handleFilterChange("site", e.target.value)}
>
  <option value="all">All Sites</option>

  {sites?.map((site) => (
    <option key={site.id} value={site.name}>
      {site.name}
    </option>
  ))}
</select>
              </div>
            </div>

            {/* Sorting Controls */}
            {/* <div className="sort-controls">
              <div className="sort-controls-group">
                <label>Sort by:</label>
                <select
                  value={sortField}
                  onChange={(e) => setSortField(e.target.value)}
                >
                  <option value="date">Date</option>
                  <option value="id">Order ID</option>
                  <option value="name">Customer Name</option>
                </select>
                <button
                  className={`sort-order-btn ${sortOrder}`}
                  onClick={() =>
                    setSortOrder(sortOrder === "asc" ? "desc" : "asc")
                  }
                >
                  <i
                    className={`fas fa-arrow-${
                      sortOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                  {sortOrder === "asc" ? "Ascending" : "Descending"}
                </button>
              </div>
              <button className="clear-filters-btn" onClick={handleClearFilters}>
                <i className="fas fa-times"></i> Clear Filters
              </button>
            </div> */}

            {/* Orders Table */}
            <div className="orders-table-container">
              {ordersLoading ? (
                <div className="loading-state">
                  <div className="loader-spinner"></div>
                  <p>Loading orders...</p>
                </div>
              ) : filteredOrders.length === 0 ? (
                <div className="empty-state">
                  <i className="fas fa-inbox"></i>
                  <p>No orders found</p>
                </div>
              ) : (
                <table className="orders-table">
                  <thead>
                    <tr>
                      <th>Order #</th>
                 
                      <th>Customer Name</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>System</th>
                      <th>Site</th>
                      <th>Serial #</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedOrders.map((order, index) => (
                      <tr key={index} className="order-row">
                        <td className="order-id">{order.id}</td>
                
                        <td className="customer-name">{order.customerName}</td>
                        <td className="order-date">
                          {new Date(order.date).toLocaleDateString()}
                        </td>
                        <td className="order-type">{getCurrencySymbol(order.currency_code)}{order.amount}</td>
                        <td className="order-system">{order.system || "—"}</td>
                        <td className="order-site">{order.siteName}</td>
                        <td className="order-serial">
                          <SerialNumberCell serialNumbers={order.serialNumbers} orderId={order.id} />
                        </td>
                        <td>
                          <span
                            className={`status-badge status-${order.status.toLowerCase()}`}
                          >
                            {order.status}
                          </span>
                        </td>
                        <td className="action-buttons">
                          <button
                            className="action-btn view-btn"
                            title="View order details"
                            onClick={() => handleViewOrderDetails(order)}
                          >
                            <i className="fas fa-arrow-right"></i>
                          </button>
                          <button
                            className="action-btn"
                            title={
                              order.status === "Cancelled"
                                ? "Download Refund Receipt"
                                : "Download Order"
                            }
                            onClick={() => handleDownloadOrder(order)}
                          >
                            <i className="fas fa-download"></i>
                          </button>
                          {!isAdmin && order.status !== "Cancelled" && (
                            <>
                              <button
                                className="action-btn"
                                title="Resend Order Confirmation"
                                onClick={() => handleResendConfirmation(order.id)}
                              >
                                <i className="fas fa-envelope"></i>
                              </button>
                              <button
                                className="action-btn cancel-btn"
                                title="Cancel Order"
                                onClick={() => handleCancelOrder(order)}
                              >
                                <i className="fas fa-ban"></i>
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            {!ordersLoading && filteredOrders.length > 0 && (
              <Pagination
                currentPage={ordersCurrentPage}
                totalPages={ordersTotalPages}
                onPageChange={setOrdersCurrentPage}
              />
            )}
          </div>

      {/* Purchase Module */}

      {/* Order Details Modal */}
      <Modal isOpen={orderDetailsModal} toggle={toggleOrderDetailsModal} centered className="modern-modal" size="lg">
        <ModalHeader toggle={toggleOrderDetailsModal} className="modal-header-custom">
          <i className="fas fa-receipt"></i>
          Order Details
        </ModalHeader>
        <ModalBody className="modal-body-custom">
          {selectedOrderDetail ? (
            <div className="order-confirmation-view">
              <div className="order-detail-box">
                <p className="order-detail-box-title">Order Details:</p>
                <div className="order-detail-box-meta">
                  <strong>Order Number:</strong> BP{selectedOrderDetail.id}
                  <br />
                  <strong>Order Date:</strong>{" "}
                  {new Date(selectedOrderDetail.date).toLocaleDateString()}
                  {selectedOrderDetail.shippingMethod && (
                    <>
                      <br />
                      <strong>Shipping Method:</strong>{" "}
                      {selectedOrderDetail.shippingMethod}
                    </>
                  )}
                  {selectedOrderDetail.deliveryDate && (
                    <>
                      <br />
                      <strong>Expected Delivery:</strong>{" "}
                      {new Date(selectedOrderDetail.deliveryDate).toLocaleDateString()}
                    </>
                  )}
                  <div className="order-detail-status-row">
                    <strong>Status:</strong>{" "}
                    <span
                      className={`status-badge status-${selectedOrderDetail.status.toLowerCase()}`}
                    >
                      {selectedOrderDetail.status}
                    </span>
                  </div>
                </div>

                <div className="order-detail-address-grid">
                  <div className="order-detail-address-col">
                    <p className="order-detail-address-label">Bill to:</p>
                    <p className="order-detail-address-text">
                      {formatAddressLabeled(selectedOrderDetail.billing_address)}
                      <strong>Phone:</strong>{" "}
                      {selectedOrderDetail.billing_address?.phone || "—"}
                      <br />
                      <strong>Email:</strong>{" "}
                      {selectedOrderDetail.billing_address?.email || "—"}
                    </p>
                  </div>
                  <div className="order-detail-address-col">
                    <p className="order-detail-address-label">Ship to:</p>
                    <p className="order-detail-address-text">
                      {formatAddressLabeled(selectedOrderDetail.shipping_address)}
                      <strong>Phone:</strong>{" "}
                      {selectedOrderDetail.shipping_address?.phone || "—"}
                      <br />
                      <strong>Email:</strong>{" "}
                      {selectedOrderDetail.shipping_address?.email || "—"}
                    </p>
                  </div>
                </div>
              </div>

              <p className="order-items-title">Items Ordered:</p>
              <table className="order-items-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th style={{ textAlign: "center" }}>Quantity</th>
                    <th style={{ textAlign: "right" }}>Price</th>
                    <th style={{ textAlign: "right" }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {(selectedOrderDetail.items || []).map((item, idx) => (
                    <React.Fragment key={idx}>
                      <tr>
                        <td>{item.product_name}</td>
                        <td style={{ textAlign: "center" }}>{item.quantity}</td>
                        <td style={{ textAlign: "right" }}>
                          {getCurrencySymbol(selectedOrderDetail.currency_code)}
                          {Number(item.unit_price || 0).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {getCurrencySymbol(selectedOrderDetail.currency_code)}
                          {(
                            Number(item.unit_price || 0) *
                            Number(item.quantity || 1)
                          ).toFixed(2)}
                        </td>
                      </tr>
                      {(item.modules || []).map((mod, mIdx) => (
                        <tr key={mIdx} className="order-items-module-row">
                          <td>{mod.name}</td>
                          <td style={{ textAlign: "center" }}>{item.quantity}</td>
                          <td style={{ textAlign: "right" }}>
                            {getCurrencySymbol(selectedOrderDetail.currency_code)}
                            {Number(mod.unit_price || 0).toFixed(2)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {getCurrencySymbol(selectedOrderDetail.currency_code)}
                            {(
                              Number(mod.unit_price || 0) *
                              Number(item.quantity || 1)
                            ).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}

                  <tr>
                    <td colSpan={3}>Product Total Price</td>
                    <td style={{ textAlign: "right" }}>
                      {getCurrencySymbol(selectedOrderDetail.currency_code)}
                      {Number(selectedOrderDetail.product_total_price || 0).toFixed(2)}
                    </td>
                  </tr>

                  {selectedOrderDetail.coupon_code &&
                    Number(selectedOrderDetail.discounted_amount || 0) > 0 && (
                      <tr>
                        <td colSpan={3}>
                          Discount ({selectedOrderDetail.coupon_code})
                        </td>
                        <td style={{ textAlign: "right" }}>
                          -{getCurrencySymbol(selectedOrderDetail.currency_code)}
                          {Number(selectedOrderDetail.discounted_amount).toFixed(2)}
                        </td>
                      </tr>
                    )}

                  {Number(selectedOrderDetail.Shipping_fee || 0) > 0 && (
                    <tr>
                      <td colSpan={3}>Shipping Fee</td>
                      <td style={{ textAlign: "right" }}>
                        {getCurrencySymbol(selectedOrderDetail.currency_code)}
                        {Number(selectedOrderDetail.Shipping_fee).toFixed(2)}
                      </td>
                    </tr>
                  )}

                  {Number(selectedOrderDetail.tax_amount || 0) > 0 && (
                    <tr>
                      <td colSpan={3}>Tax</td>
                      <td style={{ textAlign: "right" }}>
                        {getCurrencySymbol(selectedOrderDetail.currency_code)}
                        {Number(selectedOrderDetail.tax_amount).toFixed(2)}
                      </td>
                    </tr>
                  )}

                  <tr className="order-items-grandtotal-row">
                    <td colSpan={3}>Grand Total</td>
                    <td style={{ textAlign: "right" }}>
                      {getCurrencySymbol(selectedOrderDetail.currency_code)}
                      {Number(selectedOrderDetail.amount || 0).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>

              {selectedOrderDetail.additional_modules && selectedOrderDetail.additional_modules.length > 0 && (
                <div className="details-section">
                  <h4 className="section-title">
                    <i className="fas fa-plus-circle"></i> Additional Modules
                  </h4>
                  <div className="order-items-list">
                    {selectedOrderDetail.additional_modules.map((am, idx) => (
                      <div key={idx} className="order-item-card">
                        <div className="order-item-header">
                          <div className="order-item-info">
                            <div>
                              <div className="order-item-name">Additional Purchase</div>
                            </div>
                          </div>
                          <div className="order-item-price-col">
                            <div className="order-item-qty">TOTAL</div>
                            <div className="order-item-unit">{getCurrencySymbol(selectedOrderDetail.currency_code)}{Number(am.total_price || 0).toFixed(2)}</div>
                          </div>
                        </div>
                        {am.modules && am.modules.length > 0 && (
                          <div className="order-modules-list">
                            {am.modules.map((mod, mIdx) => {
                              const qty = Number(am.quantity || 1);
                              const unitPrice = am.modules.length > 0
                                ? Number(am.total_price || 0) / (am.modules.length * qty)
                                : 0;
                              const lineTotal = unitPrice * qty;
                              return (
                                <div key={mIdx} className="order-module-row">
                                  <span className="order-module-name">
                                    <i className="fas fa-puzzle-piece"></i> {mod.name}
                                  </span>
                                  <div className="order-item-price-col">
                                    <div className="order-item-unit">
                                      {qty} &times; {getCurrencySymbol(selectedOrderDetail.currency_code)}{unitPrice.toFixed(2)} = {getCurrencySymbol(selectedOrderDetail.currency_code)}{lineTotal.toFixed(2)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter className="modal-footer-custom">
          <button onClick={toggleOrderDetailsModal} className="btn-primary-modern">
            Close
          </button>
        </ModalFooter>
      </Modal>

      {/* Breakdown Modal */}
      <Modal isOpen={breakdownModal} toggle={() => setBreakdownModal(false)} centered className="modern-modal" size={breakdownType === 'modules' ? 'lg' : undefined}>
        <ModalHeader toggle={() => setBreakdownModal(false)} className="modal-header-custom">
          <i className={`fas fa-${breakdownType === 'system' ? 'server' : 'puzzle-piece'}`}></i>{" "}
          {breakdownType === 'system' ? 'System Type Breakdown' : 'Module Type Breakdown'}
        </ModalHeader>
        <ModalBody className="modal-body-custom">
          <div className={breakdownType === 'modules' ? 'breakdown-list breakdown-list-grid' : 'breakdown-list'}>
            {breakdownType === 'system' ? (
              <>
                {
                  allSystem?.map((system,i)=>(
                <SystemRow i={i} system={system} orderHistory={orderHistory}/>
                  ))
                }
          
              </>
            ) : (
              <>
                {
                  allModules?.map((module,i)=>(
                <ModuleRow i={i} module={module} orderHistory={orderHistory}/>
                  ))
                }
             
              </>
            )}
          </div>
        </ModalBody>
        <ModalFooter className="modal-footer-custom">
          <button onClick={() => setBreakdownModal(false)} className="btn-primary-modern">
            Close
          </button>
        </ModalFooter>
      </Modal>

      {/* Resend Confirmation Modal */}
      <ResendConfirmationModal
        open={resendModalOpen}
        onClose={() => setResendModalOpen(false)}
        orderId={selectedOrderIdForResend}
      />

      {/* Cancel Order Modal */}
      <CancelOrderModal
        open={cancelOrderModalOpen}
        onClose={toggleCancelOrderModal}
        order={selectedOrderForCancel}
        onCancelSuccess={handleCancelOrderSuccess}
      />
      <CreateOrderModal
        isOpen={createOrderOpen}
        toggle={() => setCreateOrderOpen(false)}
        isAdmin={isAdmin}
        userId={userId}
        distributors={distributorsList}
        defaultDistributorId={distributorFilter}
        onCreated={() => {
          setOrderStatusTab("confirmed");
          fetchOrders();
          fetchStats();
          fetchTxnStats();
        }}
      />
        </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorDashboard;
